import { SearchCollectionName } from 'api/search';
import { accountQueryKeys } from 'queries/account-query-keys';

interface SearchQueryFilter {
    query: string;
    resourceFilter: SearchCollectionName[];
    limit: number;
}

const searchQueryKeys = {
    all: () => ['search'],
    search: (accountId: number, params: SearchQueryFilter) => [
        ...accountQueryKeys.current(accountId),
        ...searchQueryKeys.all(),
        params,
    ],
};

export { searchQueryKeys };
